var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-chart-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 6V38H42V42H6V6H10ZM40.5858 12.5858L43.4142 15.4142L32 26.8284L26 20.83L17.4142 29.4142L14.5858 26.5858L26 15.1716L32 21.17L40.5858 12.5858Z",
    fill: "#F78257"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon4);
export default __webpack_public_path__ + "static/media/MissionIcon4.e336b5665d1e80cab069226b10924cd3.svg";
export { ForwardRef as ReactComponent };